import { wineUrl, wineryUrl } from '@helpers/vivinoUrls';
import { isMixedVintageWine, isNonVintageWine, isVintageWine } from '@helpers/wine';
import {
  Link,
  LinkTheme,
  Typography,
  TypographyType,
  useBreakpoint,
} from '@vivino/js-react-common-ui';
import { BasicVintage, FullVintage } from '@vivino/js-web-common';
import cx from 'classnames';
import React from 'react';

import styles from './wineHeadline.module.scss';

interface Props {
  vintage: FullVintage | BasicVintage;
}

const WineHadline = ({ vintage }: Props) => {
  const { isDesktop } = useBreakpoint();

  const year =
    isVintageWine(vintage.wine) ||
    isMixedVintageWine(vintage.wine) ||
    isNonVintageWine(vintage.wine)
      ? vintage.year
      : null;
  const winery = vintage.wine?.winery;
  return (
    <div className={styles.container}>
      <Typography
        component={'h1'}
        type={isDesktop ? TypographyType.HeadlineSmall : TypographyType.BodyExtraLarge}
      >
        <div className={styles.wineHeadline}>
          {winery && (
            <Link
              href={`${wineryUrl({ winery })}`}
              theme={LinkTheme.Quiet}
              className={cx(styles.link, styles.winery)}
            >
              {winery?.name}{' '}
            </Link>
          )}
          {year ? (
            <div className={styles.vintage}>
              <a
                href={wineUrl({ wine: vintage.wine })}
                className={cx(styles.link, styles.wineName)}
                data-cartitemsource="wine-page-master-link"
              >
                {vintage.wine.name}
              </a>{' '}
              {year}
            </div>
          ) : (
            <>{vintage.wine.name}</>
          )}
        </div>
      </Typography>
    </div>
  );
};
export default WineHadline;
